import { Box, Checkbox, Link, Typography } from "@mui/material";
import React from "react";
import { useLocales } from "../locales";

const CheckboxAgreeToCampaign =
    ({ checkboxValue, handleCheckbox }) => {
        const { translate } = useLocales();

        return (
            <Box
                sx={{
                    mb: 2,
                    ml: 2,
                }}
            >
                <span style={{ width: "max-content" }}>
                    <Checkbox
                        // label={translate("registerPage.termsAndConditionsTitle")}
                        checked={checkboxValue}
                        onClick={handleCheckbox}
                        sx={{ p: 0, mr: 1 }}
                    />

                    <label style={{ cursor: "pointer" }} onClick={handleCheckbox}>
                        <Typography variant="subtitle2" component="span">
                            {translate("checkout.agreeToCampaign")}
                        </Typography>
                    </label>
                </span>
            </Box>
        );
    }

export default CheckboxAgreeToCampaign;
